import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { FactService } from 'src/app/_services/fact.service';
import { SubTopicService } from 'src/app/_services/subTopic.service';
import { SyllabusService } from 'src/app/_services/syllabus.service';
import Swal from 'sweetalert2';
import { Proficiency } from '../../../../_models/proficiency';
declare var $ : any;
@Component({
  selector: 'app-admin-syllabus-subtopic-show',
  templateUrl: './admin-syllabus-subtopic-show.component.html',
  styleUrls: ['./admin-syllabus-subtopic-show.component.css']
})
export class AdminSyllabusSubtopicShowComponent implements OnInit {
  subTopic= undefined
  topicName=""
  serverSyllabusId=0
  facts=undefined
  server_subtopic_id=undefined
  serverTopicId=0
  newProficiency = new Proficiency()
  constructor(
    private route:ActivatedRoute,
    private subTopicService:SubTopicService,
    private syllabusService:SyllabusService,
    private factService:FactService,
    private router:Router) { }

  ngOnInit(): void {
    this.route.params.subscribe(
      params=>{
        this.server_subtopic_id=params['server_subtopic_id']
        if(this.server_subtopic_id!=0){
          this.fetchSubTopic()
          this.fetchFacts()
          this.fetchTopicInfo()
        }
      }
    )
  }

fetchSubTopic(){  this.subTopicService.getSubTopicById(this.server_subtopic_id).subscribe({
  next:(data:ResultData)=>{
         this.subTopic=data.rs.data
  }
})
}


fetchFacts(){
  this.factService.getFactsBySubTopic(this.server_subtopic_id).subscribe({
  next:(data:ResultData)=>{
         this.facts=data.rs.data
  }
})
}

fetchTopicInfo(){
  this.factService.getTopicSyllabusInfo(this.server_subtopic_id).subscribe({
  next:(data:ResultData)=>{
    let d = data.rs.data
    this.topicName =d.name
    this.serverSyllabusId=d.server_syllabus_id
    this.serverTopicId =d.id

  }
})
}
  onMoveSubTopic(){
    this.router.navigate(['/admin/subtopic/move',this.subTopic.id])
  }

  reloadTopic(){
    this.fetchSubTopic()

  }
  editSubTopicPopUp(){
    $("#editSubTopicModal").modal("show");
  }
  addProficiencyPopUp(modelId){
    $("#addProficiencyToSubtopicModal"+modelId).modal("show");
  }
  onAddProficiencyFinished(modelId){
    $("#addProficiencyToSubtopicModal"+modelId).modal("hide");
    this.reloadTopic()
  }
  onRemoveFact(factId:number){
    this.doRemoveFact(factId)
  }
  onRemoveTemplate(questionTemplateId:number){
    Swal.fire({
      title:'Oops',
      text: 'Are you sure you want to remove this template from this topic?',
      showCancelButton: true,
      confirmButtonText: 'Yes, Removed it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
        if (result.value) {
          this.doRemoveTemplate(questionTemplateId)
          Swal.fire(
            'Removed!',
            'Your template has been removed.',
            'success'
          )

        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Ok :)',
            'error'
          )
        }
      })
  }
  doRemoveTemplate(questionTemplateId:number){
    this.syllabusService.removeQuestionTemplate(this.subTopic.server_subtopic_id,questionTemplateId).subscribe(
      x=>{
        this.subTopic=x
      }
    )
  }

  doRemoveFact(factId:number){
    this.factService.removeFact(this.subTopic.server_subtopic_id,factId).subscribe(
      {
        next:(data:ResultData)=>{
          this.facts=data.rs.data

        },
        error:(err)=>{}
      }
    )
  }
  deleteProficiency(proficiencyId){
    this.syllabusService.deleteProficiency(proficiencyId).subscribe(
      x=>{
        this.subTopic=x

      }
    )
  }

  deleteProficiencyAlert(proficiencyId){
    Swal.fire({
      title:'Oops',
      text: 'Are you sure you want to remove this proficiency?',
      showCancelButton: true,
      confirmButtonText: 'Yes, Removed it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
        if (result.value) {
          this.deleteProficiency(proficiencyId)
          Swal.fire(
            'Removed!',
            'Your proficiency has been removed.',
            'success'
          )

        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Ok :)',
            'error'
          )
        }
      })

  }
  removeProficiencyTemplateAlert(proficiencyId:number, server_task_template_id:number){
    Swal.fire({
      title:'Oops',
      text: 'Are you sure you want to remove this template from proficiency?',
      showCancelButton: true,
      confirmButtonText: 'Yes, Removed it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
        if (result.value) {
          this.removeProficiencyTemplate(proficiencyId,server_task_template_id)
          Swal.fire(
            'Removed!',
            'Your proficiency has been removed.',
            'success'
          )

        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Ok :)',
            'error'
          )
        }
      })
  }

  removeProficiencyTemplate(proficiencyId:number,server_task_template_id:number){
    this.syllabusService.removeProficiencyTemplate(proficiencyId,server_task_template_id).subscribe(
      x=>{
        this.subTopic=x

      }
    )
  }
}

